// extracted by mini-css-extract-plugin
module.exports = {"className":"textInspirationalTitleXL_className__8Fwoo"};